import { jsxs as c, Fragment as f, jsx as r } from "react/jsx-runtime";
import { useState as u } from "react";
import { formatDate as C } from "../../helpers/dates.js";
import b from "@mui/material/Button";
import g from "@mui/material/Popover";
import k from "dayjs";
import { CalendarIcon as v, StaticDatePicker as x } from "@mui/x-date-pickers";
const E = ({ selectedDate: n, onChange: s }) => {
  const [e, t] = u(null), m = (o) => {
    t(o.currentTarget);
  }, a = () => {
    t(null);
  }, p = (o) => {
    t(null), o && s(o.toDate());
  }, { longMonth: d, dateNumber: h } = C(n), i = !!e, l = i ? "simple-popover" : void 0;
  return /* @__PURE__ */ c(f, { children: [
    /* @__PURE__ */ c(b, { "data-testid": "day-picker-button", "aria-describedby": l, variant: "text", onClick: m, startIcon: /* @__PURE__ */ r(v, {}), children: [
      d,
      " ",
      h
    ] }),
    /* @__PURE__ */ r(
      g,
      {
        id: l,
        open: i,
        anchorEl: e,
        onClose: a,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        children: /* @__PURE__ */ r(x, { onClose: a, onAccept: p, defaultValue: k(n), displayStaticWrapperAs: "mobile" })
      }
    )
  ] });
};
export {
  E as DatePickerButton
};
//# sourceMappingURL=datepicker.js.map
